/// <amd-module name="Wit/UI/Components/WorkItemState/index" />
export * from "./WorkItemState.Props";
export * from "./WorkItemState";